import {
  Dialog,
  DialogBody,
  DialogButton,
  DialogButtons,
  DialogCloseX,
  DialogContent,
  DialogHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  open: boolean;
  setOpen: (o: boolean) => void;
  resendInvitation: MouseEventHandler<HTMLButtonElement>;
  email: string;
}

const polyglotPrefix =
  "pages.data_sharing.manage_invitation.resend_invitation."

/*
 * renders a dialog asking the user to resend an invitation
 */
export function ResendInvitationDialog(props: Props) {
  const {
    setOpen, open: isOpen, resendInvitation, email,
  } = props

  const polyglot = usePolyglot()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setOpen}
    >
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}title`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          <div>
            {polyglot.t(
              `${polyglotPrefix}description_one`,
              { email },
            )}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_two`)}
          </div>
        </DialogBody>
        <DialogButtons>
          <DialogButton stylePreset="secondary">
            {polyglot.t(`${polyglotPrefix}cancel_cta`)}
          </DialogButton>
          <DialogButton
            id="confirm-resend-invitation-btn"
            stylePreset="primary"
            onClick={resendInvitation}
          >
            {polyglot.t(`${polyglotPrefix}yes_cta`)}
          </DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}
